import { loadEnterpriseReCaptchaScript, loadFreeReCaptchaScript, useCaptchaChallengeCallback, useCaptchaChallengeEventHandler, useRequestCaptchaChallenge } from '@atlassian/commerce-recaptcha-base';
import { useHAMSRequestSiteKey } from './services/hams';
export { ReCaptchaLegalText, RawReCaptchaLegalText } from '@atlassian/commerce-recaptcha-base';
export { isSuccessful, isFailure, isError, isException } from '@atlassian/commerce-resultful';
export { HAMSReCaptchaErrorMessage } from './ui';
export { loadEnterpriseReCaptchaScript, loadFreeReCaptchaScript };

/**
 * A low level alternative to {@link useCaptchaChallengeEventHandler}. The difference is that this
 * callback requires a HTML element to be passed in rather than an event.
 *
 * Note: In order to avoid introducing bugs into reCAPTCHA, please understand the various assumptions
 * required in order to handle reCAPTCHA edge cases (see reCAPTCHA documents).
 *
 * @param operation This depends on your product. See: https://hello.atlassian.net/wiki/spaces/~261604415/pages/1169536418/Hams+Captcha+Tech+Implementation+Overview
 * @param initializeOptions Customizable settings for this hook
 * @returns A result with the reCAPTCHA token inside of it
 */
export var useHAMSRequestCaptchaChallenge = function useHAMSRequestCaptchaChallenge(operation, options) {
  var requestSiteKey = useHAMSRequestSiteKey(operation, options === null || options === void 0 ? void 0 : options.siteKeyBaseUrl);
  return useRequestCaptchaChallenge(requestSiteKey, options);
};
/**
 * @deprecated Use {@link useHAMSRequestCaptchaChallenge} or ${@link useHAMSCaptchaChallengeEventHandler} instead.
 *
 * @param operation This depends on your product. See: https://hello.atlassian.net/wiki/spaces/~261604415/pages/1169536418/Hams+Captcha+Tech+Implementation+Overview
 * @param callback A callback that get's called after retrieving a reCAPTCHA result
 * @param initializeOptions Customizable settings for this hook
 * @returns A callback that you can pass into an event handling prop (like the onClick of a button)

 */

export var useHAMSCaptchaChallengeCallback = function useHAMSCaptchaChallengeCallback(operation, onReCaptchaChallengeCallback, options) {
  var requestSiteKey = useHAMSRequestSiteKey(operation, options === null || options === void 0 ? void 0 : options.siteKeyBaseUrl);
  return useCaptchaChallengeCallback(requestSiteKey, onReCaptchaChallengeCallback, options);
};

/**
 * A ref callback hook that instruments element(s) with reCAPTCHA.
 *
 * @param operation This depends on your product. See: https://hello.atlassian.net/wiki/spaces/~261604415/pages/1169536418/Hams+Captcha+Tech+Implementation+Overview
 * @param onReCaptchaChallengeCallback A callback that get's called after retrieving a reCAPTCHA result
 * @param initializeOptions Customizable settings for this hook
 * @returns A ref callback. Pass this into the element that you want to be instrumented with reCAPTCHA.
 */
export var useHAMSCaptchaChallengeEventHandler = function useHAMSCaptchaChallengeEventHandler(operation, onReCaptchaChallengeCallback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var requestSiteKey = useHAMSRequestSiteKey(operation, options === null || options === void 0 ? void 0 : options.siteKeyBaseUrl);
  return useCaptchaChallengeEventHandler(requestSiteKey, onReCaptchaChallengeCallback, options);
};